import { Button, Heading, HFlow, VFlow } from 'bold-ui'
import { FormRenderProps } from 'components/form'
import theme from 'config/theme'
import React, { useState } from 'react'

import { EstadoCamposUnificacaoBase } from './ConfiguracoesUnificacaoBaseBox'
import { ModalCancelarSolicitacao } from './ModalCancelarSolicitacao'
import { SolicitacaoEnvioModel } from './SolicitacaoEnvioForm'

interface CancelarSolicitacaoEnvioProps {
  solicitacaoId: string
  formSolicitarEnvio: FormRenderProps<SolicitacaoEnvioModel>
  setEstadoCamposForms(estadoCampos: EstadoCamposUnificacaoBase): void
}

export const CancelarSolicitacaoEnvio = (props: CancelarSolicitacaoEnvioProps) => {
  const { solicitacaoId, formSolicitarEnvio, setEstadoCamposForms } = props
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

  return (
    <HFlow
      style={{
        border: `1px solid ${theme.pallete.divider}`,
        padding: '1rem',
      }}
      alignItems='flex-start'
    >
      <VFlow>
        <Heading level={3}>Solicitação enviada com sucesso</Heading>
        <p>A instalação destino recebeu sua solicitação de envio.</p>
      </VFlow>

      <Button size='small' skin='outline' kind='primary' onClick={() => setIsModalOpen(true)}>
        Cancelar solicitação
      </Button>

      <ModalCancelarSolicitacao
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
        solicitacaoId={solicitacaoId}
        formSolicitarEnvio={formSolicitarEnvio}
        setEstadoCamposForms={setEstadoCamposForms}
      />
    </HFlow>
  )
}
